import api from '../api'

export default api.resource({
  path    : 'schedules',
  keyName : 'id',
  schema  : {
  }
})
